/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "cash": {
        "nested": {
          "grantly": {
            "nested": {
              "api": {
                "nested": {
                  "SessionScope": {
                    "fields": {
                      "type": {
                        "type": "squareup.cash.grantly.api.SessionScope.Type",
                        "id": 1,
                        "rule": "required"
                      },
                      "requestsDecideScopeDetails": {
                        "type": "squareup.cash.grantly.api.SessionScope.RequestsDecideScopeDetails",
                        "id": 2
                      }
                    },
                    "nested": {
                      "Type": {
                        "values": {
                          "REQUESTS_DECIDE": 1
                        }
                      },
                      "RequestsDecideScopeDetails": {
                        "fields": {
                          "actionTypes": {
                            "type": "squareup.cash.grantly.api.SessionScope.RequestsDecideScopeDetails.ActionType",
                            "id": 1,
                            "rule": "repeated"
                          }
                        },
                        "nested": {
                          "ActionType": {
                            "values": {
                              "ONE_TIME_PAYMENT": 1,
                              "ON_FILE_PAYMENT": 2
                            }
                          }
                        }
                      },
                      "details": {
                        "oneof": ["requestsDecideScopeDetails"]
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.SessionScope && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.SessionScope?.nested?.Type && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.SessionScope?.nested?.RequestsDecideScopeDetails && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.SessionScope?.nested?.RequestsDecideScopeDetails?.nested?.ActionType) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE SessionScope @ squareup/cash/grantly/api/session.proto at 84:1
 */
export const SessionScope = $root.lookupType('squareup.cash.grantly.api.SessionScope');
fixType(SessionScope);
Builder.createAndAttachToType(SessionScope);
/**
 * Represents the types of scopes that session wants authorization for
 * to perform on a customer's behalf.
 *
 * SOURCE Type @ squareup/cash/grantly/api/session.proto at 105:3
 */
SessionScope.Type = $root.lookupEnum('squareup.cash.grantly.api.SessionScope.Type').values;
/**
 * Represents the details relevant to the ability to decide customer requests.
 *
 * SOURCE RequestsDecideScopeDetails @ squareup/cash/grantly/api/session.proto at 112:3
 */
SessionScope.RequestsDecideScopeDetails = $root.lookupType('squareup.cash.grantly.api.SessionScope.RequestsDecideScopeDetails');
fixType(SessionScope.RequestsDecideScopeDetails);
Builder.createAndAttachToType(SessionScope.RequestsDecideScopeDetails);
/**
 * Represents the type of requests the session would like to decide on a customer's behalf.
 *
 * SOURCE ActionType @ squareup/cash/grantly/api/session.proto at 121:5
 */
SessionScope.RequestsDecideScopeDetails.ActionType = $root.lookupEnum('squareup.cash.grantly.api.SessionScope.RequestsDecideScopeDetails.ActionType').values;